/**
 * error message list
 * Created by wen on 2017/8/27.
 */

var errorMessageList = {
    RequestTimeout  : '通讯超时，请稍后再试，或尝试切换其他网络。',
    RequestConflict : '操作存在冲突，内容重复或存在依赖的数据',
    defaultText : '出错了，请稍后再试'
};




/** WEBPACK FOOTER **
 ** D:/app project/shixun-web/src/shixun-mobile/common/errorMessageList.js
 **/